import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Tabs, Layout, Typography } from "antd";

import PageLayout from "../../components/PageLayout";
import Subscription from "./Subscription";
import TransactionHistory from "./TransactionHistory";
import SubscriptionHistory from "./SubscriptionHistory";
import useIsMobile from "../../hooks/useIsMobile";

import HeaderIconSvg from "../../icons/newicons/arrow-down-up.svg";

import "./Payment.css";

const Payment = () => {
  const { TabPane } = Tabs;
  const { Title } = Typography;

  const isMobile = useIsMobile();

  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "pk_test_51RBFlLKzdWlqF8gVi8pYmgbDMjADSOYp0WPQMastmT6dPQBUHI6BOK27a98jLzUJF3UqJTfYGqMcAVdMu4nuC79v00XywtzBm6"
  );

  const options = {
    // Disable Link
    loader: "auto",
    fonts: [],
    // Disable Link popup/save card behavior
    components: {
      linkAuthentication: false,
    },
  };

  const [activeTab, setActiveTab] = useState(0);

  return (
    <PageLayout icon={HeaderIconSvg} heading="Payment" hideSearchBar={true}>
      <Elements stripe={stripePromise} options={options}>
        <div className="payment-page-container">
          <div className="flex flex-middle mt-8 flex-between groups-tabs payment-page-tabs">
          <div className={`tabs flex`}>
            <div
              className={`ht-60 flex flex-middle pl-16 pr-16 fw-bolder c-pointer bg-lt-gray-2 ${
                activeTab === 0 ? "bg-white c-gray" : "c-white border-gray"
              } fw-bolder'`}
              onClick={() => {
                setActiveTab(0);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="24"
                fill="currentColor"
                class="bi bi-credit-card"
                viewBox="0 0 16 16"
              >
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1H2zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7z"/>
                <path d="M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-1z"/>
              </svg>
              <span>Subscription</span>
            </div>
            <div
              className={`ht-60 flex flex-middle pl-16 pr-16 fw-bolder c-pointer bg-lt-gray-2 ${
                activeTab === 1 ? "bg-white c-gray" : "c-white border-gray"
              }`}
              onClick={() => {
                setActiveTab(1);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="24"
                fill="currentColor"
                class="bi bi-clock-history"
                viewBox="0 0 16 16"
              >
                <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022l-.074.997zm2.004.45a7.003 7.003 0 0 0-.985-.299l.219-.976c.383.086.76.2 1.126.342l-.36.933zm1.37.71a7.01 7.01 0 0 0-.439-.27l.493-.87a8.025 8.025 0 0 1 .979.654l-.615.789a6.996 6.996 0 0 0-.418-.302zm1.834 1.79a6.99 6.99 0 0 0-.653-.796l.724-.69c.27.285.52.59.747.91l-.818.576zm.744 1.352a7.08 7.08 0 0 0-.214-.468l.893-.45a7.976 7.976 0 0 1 .45 1.088l-.95.313a7.023 7.023 0 0 0-.179-.483zm.53 2.507a6.991 6.991 0 0 0-.1-1.025l.985-.17c.067.386.106.778.116 1.17l-1.001.025zm-.131 1.538c.033-.17.06-.339.081-.51l.993.123a7.957 7.957 0 0 1-.23 1.155l-.964-.267c.046-.165.086-.332.12-.501zm-.952 2.379c.184-.29.346-.594.486-.908l.914.405c-.16.36-.345.706-.555 1.038l-.845-.535zm-.964 1.205c.122-.122.239-.248.35-.378l.758.653a8.073 8.073 0 0 1-.401.432l-.707-.707z"/>
                <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0v1z"/>
                <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5z"/>
              </svg>
              <span>Subscription History</span>
            </div>
            <div
              className={`ht-60 flex flex-middle pl-16 pr-16 fw-bolder c-pointer bg-lt-gray-2 ${
                activeTab === 2 ? "bg-white c-gray" : "c-white border-gray"
              }`}
              onClick={() => {
                setActiveTab(2);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="24"
                fill="currentColor"
                class="bi bi-receipt"
                viewBox="0 0 16 16"
              >
                <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647A.5.5 0 0 1 9.708 0h.586a1.5 1.5 0 0 1 1.5 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 13.5v-12A1.5 1.5 0 0 1 1.5 0h.586a.5.5 0 0 1 .434.14zM2 1.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-12a.5.5 0 0 0-.5-.5h-9z"/>
                <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"/>
              </svg>
              <span>Transaction History</span>
            </div>
          </div>
        </div>
        </div>

        <div>
          {activeTab === 0 ? (
            <Subscription setActiveTab={setActiveTab} />
          ) : activeTab === 1 ? (
            <SubscriptionHistory />
          ) : (
            <TransactionHistory />
          )}
        </div>
      </Elements>
    </PageLayout>
  );
};

export default Payment;
